module.exports = __webpack_public_path__ + "img/POISSON.e5c0ad6f.png";